import { render } from "./SettingsTitle.vue?vue&type=template&id=a6e0eb00"
import script from "./SettingsTitle.vue?vue&type=script&lang=js"
export * from "./SettingsTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__